export class Page {
  constructor(public id: number, public carrierId: any, public next: number, public previous: number,
    public visibility: boolean, public isEdit: boolean) { }

}
